<!-- 出货形式 -->
<template>
  <BaseFormItem
    class="units"
    :label="label"
    :labelTips="labelTips"
  >
    <BaseRadioGroup v-model="val" @change="handleChange">
      <BaseTipPopover 
        v-for="item in options"
        :key="item.value" 
        :content="item.tips" 
        :disabled="!item.tips"
      >
        <el-radio-button
          slot="reference"
          :label="item.value"
        >{{ item.label }}</el-radio-button>
      </BaseTipPopover>
    </BaseRadioGroup>

    <div slot="other">
      <BaseTextButton 
        v-if="val == 2"
        @click="handleOpenBoardDialog(false)"
      >修改拼板</BaseTextButton>

      <!-- PCBA下单提示 -->
      <span v-if="isShowTips" class="units__tips">
        单片数量较多，建议选择【连片(华秋代拼)】
      </span>
    </div>
    <div class="units__tips" v-if="this.isSmt && (this.val == 1 || this.val == 3)">
      因 SMT 生产工艺需求,我方将按需添加工艺边,支持上下、左右或四周各加 5mm,不再另行告知。
    </div>
  </BaseFormItem>
</template>

<script>
import { getFR4Fields } from '@@/utils/getFields'

export default {
  props: {
    value: {
      type: Number,
      default: 0
    },
    bcount: {
      type: [Number, String],
      default: ''
    },
    length: {
      type: [String, Number],
      default: ''
    },
    width: {
      type: [String, Number],
      default: ''
    },
    isSmt: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      val: this.value,
      preVal: this.value
    }
  },
  computed: {
    fields() {
      return getFR4Fields('units')
    },
    label() {
      return this.isSmt ? '拼板方式' : this.fields.label
    },
    labelTips() {
      const { fields, isSmt } = this
      const labelTips = fields.labelTips
      return labelTips + (isSmt ? '若您需要添加工艺边，请选择此「连片(华秋代拼)」方式。' : '')
    },
    options() {
      const { fields, isSmt } = this
      const smtTips = isSmt ? {
        1: '单板出货为单块 PCB 独立出货，不包含工艺边。若您需要添加工艺边，请选择「连片 (华秋代拼)」',
        2: '，支持定制工艺边，满足 SMT 贴片等工艺需求'
      } : {}

      return fields.options.map(item => {
        const { value, tips } = item
        return { ...item, tips: (tips || '') + (smtTips[value] || '') }
      })
    },
    // 是否显示PCBA下单提示
    isShowTips() {
      const { val, isSmt, bcount, length, width } = this
      if (isSmt && bcount && length && width) {
        // PCBA下单 && 单片出货 && 数量 >= 100 && 小边 <= 22.5cm
        return val == 1 && bcount >= 100 && Math.min(length, width) <= 22.5 
      }
      return false
    }
  },
  watch: {
    value(newVal, oldVal) {
      this.val = newVal
    },
    val(newVal, oldVal) {
      this.preVal = oldVal
    }
  },
  methods: {
    handleEmit() {
      const val = this.val
      this.$emit('input', val)
      this.$emit('change', val)
    },
    handleChange() {
      if (this.val == 2) {
        this.handleOpenBoardDialog(this.preVal)
      } else if (this.preVal == 2) {
        // 从连片(华秋代拼)切换到别的选项时，弹框提示
        this.$alert('修改出货形式参数会影响拼板参数，会清空当前拼板参数，请确认是否继续修改？', '温馨提示', {
          center: true,
          lockScroll: false,
          showCancelButton: true,
          closeOnPressEscape: true,
          confirmButtonText: '确认',
          customClass: 'alert-fields-tips',
          callback: action => {
            // 取消
            if (action === 'cancel') {
              this.val = 2
              this.handleEmit()
            } else {
              // 确认
              this.$emit('reset')
            }
          }
        })
      }
      this.handleEmit()
    },
    handleOpenBoardDialog(preVal) {
      this.$emit('open', preVal)
    }
  }
}
</script>

<style lang="scss" scoped>
.units {
  .units__tips {
    font-size: 12px;
    color: $--color-warning;
  }
}
</style>